<script setup>
import Button from '@/Components/Button.vue';
import { computed } from 'vue';

const props = defineProps({
  totalResults: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  queryObject: {
    type: Object,
    required: true,
  },
  slug: {
    type: String,
    required: true,
  }
});
const totalPages = computed(() => {
  return Math.ceil(props.totalResults / 10);
});
const queryData = computed(() => {
  if(!props.queryObject.page) {
    return {...props.queryObject, page: 1};
  }
  return props.queryObject;
});
</script>


<template>
  <div class="w-full flex justify-around">
    <div class="hidden md:block">
      <Button
        v-if="currentPage > 1"
        aria-label="Previous page"  
        class="mx-2 text-grey" 
        variant="link" 
        type="link" 
        :data="{...queryData, page: currentPage - 1}"
        :link="`/${slug}`"
      >
        Previous
      </Button>
    </div>
    <div class="flex">
      <Button
        v-if="currentPage > 3"
        aria-label="First page"  
        class="mx-2" 
        variant="pagination" 
        type="link"  
        :data="{...queryData, page: 1}"
        :link="`/${slug}`"
      >
        1
      </Button>
      <p v-if="currentPage > 4" class="my-auto">...</p>

      <Button
        v-if="currentPage > 2"
        :aria-label="`currentPage === 2 ? 'First page' : Page ${currentPage - 2}`" 
        class="mx-2"
        :link="`/${slug}`" 
        :data="{...queryData, page: currentPage - 2}" 
        variant="pagination" 
        type="link"
      >
        {{ currentPage - 2 }}
      </Button>
      <Button
        v-if="currentPage > 1"
        :aria-label="currentPage === 2 ? 'First page' : `Page ${currentPage - 1}`" 
        class="mx-2"
        :link="`/${slug}`" 
        :data="{...queryData, page: currentPage - 1}" 
        variant="pagination" 
        type="link"
      >
        {{ currentPage - 1 }}
      </Button>
      <Button
        :aria-label="currentPage === 1 ? 'First page' : `Page ${currentPage}`"
        class="mx-2 bg-primary text-white" 
        variant="pagination" 
        type="link"
        :data="{...queryData}" 
        :link="`/${slug}`"
      >
        {{ currentPage }}
      </Button>
      <Button
        v-if="(currentPage + 1) <= totalPages"
        :aria-label="`Page ${currentPage + 1}`" 
        class="mx-2" 
        :link="`/${slug}`" 
        :data="{...queryData, page: currentPage + 1}" 
        variant="pagination" 
        type="link"
      >
        {{ currentPage + 1 }}
      </Button>
      <Button
        v-if="(currentPage + 2) <= totalPages"
        :aria-label="`Page ${currentPage + 2}`" 
        class="mx-2" 
        :link="`/${slug}`" 
        :data="{...queryData, page: currentPage + 2}" 
        variant="pagination" 
        type="link"
      >
        {{ currentPage + 2 }}
      </Button>

      <p v-if="(currentPage + 4) <= totalPages" class="my-auto">...</p>
      <Button
        v-if="(currentPage + 3) <= totalPages"
        aria-label="`Last page of ${totalPages}`"  
        class="mx-2" 
        variant="pagination" 
        type="link" 
        :data="{...queryData, page: totalPages}" 
        :link="`/${slug}`"
      >
        {{ totalPages }}
      </Button>
    </div>


    <div class="hidden md:block">
      <Button
        v-if="currentPage < totalPages"
        aria-label="Next page"  
        class="mx-2 text-grey" 
        variant="link" 
        type="link" 
        :data="{...queryData, page: currentPage + 1}" 
        :link="`/${slug}`"
      >
        Next
      </Button>
    </div>
  </div>
</template>